import { useNavigate, useParams } from "react-router-dom";
import Dataset from "datasets/types/interfaces/dataset";
import { useFetcher } from "~/hooks/useFetcher";
import { ROUTE_404 } from "~/router/constants";

const { VITE_CATALOG_API } = import.meta.env;

const useDataset = (id?: string) => {
  const navigate = useNavigate();
  // Only redirect to 404 when datasetId came from the URL itself — callers
  // that pass `id` explicitly (e.g. the session context sidebar) are
  // embedded outside the /datasets/:datasetId route, so a 4xx here should
  // surface as an inline error rather than yanking the user off their
  // current page.
  const { datasetId: routeDatasetId } = useParams();
  const datasetId = routeDatasetId ?? id;
  const resp = useFetcher<Dataset>(datasetId ? `${VITE_CATALOG_API}/datasets/${datasetId}` : null);

  if (routeDatasetId && resp.error?.status >= 400 && resp.error.status < 500) {
    navigate(ROUTE_404, { replace: true });
  }

  return resp;
};

export default useDataset;
